import React, {useState, useEffect} from "react";
import { Accordion } from "react-bootstrap";
import {useLocation} from 'react-router-dom';
import {SetMetaData} from './../../helper/page-title';
import {LoaderMedium} from './../../components/loader';
import { AccordionSecUI } from "../../components/portfolio/common";
import FormInput from "../../components/form/input";
import {post_api_call, error_api_call} from './../../actions/action-creators/common';
import {toggleBodyLoader} from './../../helper/custom-function';
import ValidationHelper from '../../helper/validation';
import { alertResponseMessage } from "../../actions/action-creators/response";
import { nominationGroupOptions,
        // nominationProgramOptions,
        yesNoOption,
        // monthOption,
        schoolBoardOption,
        schoolTypeOption
    } from "../../components/select/option";

function SchoolNomination(){
    SetMetaData("School Nomination", "", "");
    const location = useLocation();
    const [pageLoading, setPageLoader] = useState(false);
    const [formData, setFormData] = useState({
                                                nominate_type: 'form',
                                                email: '',
                                                name_address: '',
                                                board_ids: [],
                                                is_board_other: false,
                                                board_name: '',
                                                implement_type: '',
                                                school_count: '',
                                                student_count: '',
                                                school_type: '',
                                                // start_month: '',
                                                // end_month: '',
                                                // program_ids: [],
                                                integration_agree: false,
                                                coordination_agree: false,
                                                selection_criteria: '',
                                                is_affi_internationally: '',
                                                organisation_name: '',
                                                // committee_contact: '',
                                                principal_contact: '',
                                                nominated_contact: '',
                                            });
    const [errorData, setErrorData] = useState([]);
    const [isProcess, setIsProcess] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    //Redirection Url
    useEffect(() => {
        const urlHandling = () => {
          try{
            setPageLoader(true);
            // const urlQuryString = window.location.search;
            const urlQuryString = location.search;
            const urlParam = new URLSearchParams(urlQuryString);
            // var urlRedirect = urlParam.get('redirect_uri');
            const urlEmail = urlParam.get('email');
            if(urlEmail && ValidationHelper.validateEmail(urlEmail)){
                setFormData({...formData, email: urlEmail});
            }
            setPageLoader(false);
            // else{
            //     urlRedirect = (urlRedirect !== '' && urlRedirect !== null) ? urlRedirect : '/';
            //     window.location.href = urlRedirect;
            // }
          }catch(e){
            error_api_call({error: `screens|school|nomination|urlHandling|${e}`});
          }
        }
        urlHandling();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //Update Input
    const updateInput = (identifier_type, input_type, field, value) => {
        try{
            console.log(identifier_type, input_type, field, value)
            setErrorData([]);
            if(field === 'student_count'){
                if(value.length < 7){
                    value = value.replace(/[^0-9]/g, '');
                }else{
                    return false;
                }
            }else if(field === 'principal_contact'){
                if(value.length < 16){
                    value = value.replace(/[^0-9]/g, '');
                }else{
                    return false;
                }
            }else if(input_type === 'input'
                || input_type === 'textarea'
            ){
                value = value.trimStart();
            }

            var fieldData = {...formData};
            
            if(field === 'board_ids'){
                if(value && value.length){
                    var checkInvitedOther = false;
                    value.forEach(inp_board => {
                        if(inp_board.id === 0){
                            checkInvitedOther = true;
                        }
                    });
                    fieldData['is_board_other'] = checkInvitedOther;
                    if(!checkInvitedOther){
                        fieldData['board_other'] = '';
                    }
                }else{
                    fieldData['board_other'] = '';
                    fieldData['is_board_other'] = false;
                }
            }

            fieldData[field] = value;
            setFormData({...fieldData});
    
        }catch(e){
            console.error(e);
            error_api_call({error: `screens|school|nomination|updateInput|${e}`});
        }
    }
    //Options
    const schoolCountOptions = () => {
        var schlCountOptn = [];
        try{
            for (let i = 2; i < 11; i++) {
                schlCountOptn.push({id: i, count: i});
            }
            schlCountOptn.push({id: 11, count: '10+'});
        }catch(error){
            console.error(error);
        }
        return schlCountOptn;
    }
    //Submit Form
    const submitForm = async(e) => {
        try{
            e.preventDefault();
            setErrorData([]);
            setIsProcess(true);
            toggleBodyLoader('load');
            var boardIds = [];
            var boardText = [];//Useful to send in mail
            //Validation
            var validation = [];
            const inpFormData = {...formData};
            if(!inpFormData.email
                || !ValidationHelper.validateEmail(inpFormData.email)
            ){
                validation.push("'Principal’s Email' required, should be valid & should be within 150 characters");
            }
            if(!inpFormData.name_address
                || inpFormData.name_address.length > 250
            ){
                validation.push("1.1-'Name of your academic institution and address' required & should be within 250 characters");
            }
            if(inpFormData.board_ids.length === 0){
                validation.push("1.2-'Which of the following syllabi are...' please select");
            }else{
                var checkBoostOther = false;
                inpFormData.board_ids.forEach(inp_board => {
                    if(inp_board.id === 0){
                        checkBoostOther = true;
                    }else{
                        boardIds.push(inp_board.id);
                        boardText.push(inp_board.label);
                    }
                });
                if(checkBoostOther
                    // && inpFormData.board.length === 1
                    && (!inpFormData.board_name || inpFormData.board_name.length > 50)
                ){
                    validation.push("1.2.1-'Syllabi offered to students in your...' required & should be within 50 characters");
                }
            }
            if(!inpFormData.implement_type){
                validation.push("1.3-'Are you nominating IFSPD Europe Future...' required");
            }else if(inpFormData.implement_type === 2 && (!inpFormData.school_count || typeof inpFormData.school_count.id === "undefined")){
                validation.push("1.3.1-'How many schools in your group are you nominating?' required");
            }
            if(!inpFormData.student_count || /[^0-9]/.test(inpFormData.student_count)){
                validation.push("1.4-'How many students are there totally in your school?' required");
            }
            if(!inpFormData.school_type){
                validation.push("1.5-'School Type' required");
            }
            // if(typeof inpFormData.start_month.id === "undefined"){
            //     validation.push("1.5-'Start Month' required");
            // }
            // if(typeof inpFormData.end_month.id === "undefined"){
            //     validation.push("1.5-'End Month' required");
            // }
            // if(inpFormData.program_ids.length === 0){
            //     validation.push("2.1-'Please select the programs...' required");
            // }
            if(!inpFormData.integration_agree){
                validation.push("2.1-'If your school is selected, do you...' required");
            }
            if(!inpFormData.coordination_agree){
                validation.push("2.2-'If your school is selected, do you agree...' required");
            }
            if(inpFormData.selection_criteria
                && inpFormData.selection_criteria.length > 300
            ){
                validation.push("2.3-'What selection criteria and enrollment strategies...' should be within 300 characters");
            }
            if(!inpFormData.is_affi_internationally){
                validation.push("2.4-'Are you officially affiliated with any...' required");
            }else if(inpFormData.is_affi_internationally === 1
                && (!inpFormData.organisation_name
                    || inpFormData.organisation_name.length > 100)
            ){
                validation.push("2.4.1-'Name of the international organisation' required & should be within 100 characters");
            }
            // if(!inpFormData.committee_contact
            //     || inpFormData.committee_contact.length > 300
            // ){
            //     validation.push("3.1-'Contact details along with mobile...' required & should be within 300 characters");
            // }
            // if(!inpFormData.principal_contact
            //     || inpFormData.principal_contact.length > 300
            // ){
            //     validation.push("3.1-'Mobile number of the Principal of your school...' required & should be number");
            // }
            if(!inpFormData.principal_contact || /[^0-9]/.test(inpFormData.principal_contact)){
                validation.push("3.1-'Mobile number of the Principal of your school...' required & should be number");
            }
            if(inpFormData.nominated_contact
                && inpFormData.nominated_contact.length > 300
            ){
                validation.push("3.2-'Contact details along with mobile...' should be within 300 characters");
            }

            if(validation.length > 0){
                setErrorData([...validation]);
                setIsProcess(false);
            }else{
                // var programIds = [];
                var apiFormData = inpFormData;
                apiFormData.board_ids = boardIds;
                if(apiFormData.is_board_other){
                    boardText.push(apiFormData.board_name);
                }else{
                    apiFormData.board_name = '';
                }
                apiFormData.board_text = boardText;
                apiFormData.school_count = apiFormData.implement_type === 2
                                            ? apiFormData.school_count.id
                                            : null;
                apiFormData.school_type_text = schoolTypeOption.find(o => o.id === apiFormData.school_type)?.label;
                // apiFormData.student_count = apiFormData.student_count;
                // apiFormData.start_month = apiFormData.start_month.id;
                // apiFormData.end_month = apiFormData.end_month.id;
                // apiFormData.is_affi_internationally = apiFormData.is_affi_internationally.id;
                apiFormData.organisation_name = apiFormData.is_affi_internationally === 1
                                                ? apiFormData.organisation_name
                                                : null;

                // apiFormData.program_ids.forEach(inp_imp => {
                //     programIds.push(inp_imp.id);
                // });
                // apiFormData.program_ids = programIds;
                
                delete apiFormData.is_board_other;

                const insertApi = await post_api_call(`nominate-school`, apiFormData);
            
				if(insertApi.status === 200){
                    setIsSuccess(true);
                    alertResponseMessage({alert_type: 1, message: "Request sent Successfully! We have received your nomination. Will let you know the results soon."});
                }else{
                    if(typeof insertApi.message !== "undefined"){
                        setErrorData([insertApi.message]);
                    }else{
                        setErrorData(['Something Went Wrong, Please Try After Some Time']);
                    }
                }
                setIsProcess(false);
            }
            toggleBodyLoader('remove');
        }catch(error){
            console.error(error);
            toggleBodyLoader('remove');
            setErrorData(['Something Went Wrong, Please Try After Some Time']);
            setIsProcess(false);
            error_api_call({error: `screens|school|nomination|submitForm|${error}`});
        }
    }

    return (
        <>
        <main id="main">
            <section className="team-sec pt-0 portfolio-edit">
                <div className="container-fluid container-lg">
                    <div className="row">
                        <div className="col-12 col-md-12 col-sm-12">
                            <div className="section-header section-header-1">
                                <h1 className="title">School Nomination Form:<br/>Future Global Leaders Fellowship</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="row justify-content-center team-detail mt-1 mb-4 mt-3">
                            {pageLoading 
                            ? 
                                <div className="text-center mt-5 mb-5">
                                    <LoaderMedium size={45} />
                                </div>
                            :
                                <>
                                <div className="col-md-12 col-12 col-sm-12">
                                    <div className="card-box p-3 pt-1">
                                        {isSuccess
                                        ?
                                        <div className="alert alert-success text-center mb-0" role="alert">
                                            <strong className="fs-1">Thank You!</strong>
                                            <p className="mt-2 fs-5">We have received your nomination. Once our evaluation is complete, we shall let you know the results. In case of clarifications, please get in touch with <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} title="Director Email Address">{process.env.REACT_APP_SUPPORT_EMAIL}</a>.</p>
                                        </div>
                                        :
                                        <>
                                        <div className="mod-form-input mb-4">
                                            <fieldset>
                                                <FormInput
                                                    colMd= "12"
                                                    formCls="mb-0"
                                                    label= "Principal’s Email"
                                                    required= {true}
                                                    type= "email"
                                                    name= "email"
                                                    data={formData}
                                                    updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                />
                                            </fieldset>
                                        </div>
                                        <Accordion defaultActiveKey="0">
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>
                                                    <AccordionSecUI
                                                        title={"About Your School"}
                                                    />
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="mod-form-input">
                                                        <fieldset className="row">
                                                            <FormInput
                                                                colMd= "12"
                                                                label= "1.1. Name of your academic institution and address"
                                                                required= {true}
                                                                type= "text"
                                                                name= "name_address"
                                                                data={formData}
                                                                count= {250}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            <FormInput
                                                                colMd = "12"
                                                                widthCls = "w-50 w-xs-100 w-sm-50"
                                                                label = "1.2. Which of the following syllabi are offered to students in your school currently?"
                                                                required = {true}
                                                                type = "multi-select"
                                                                name = "board_ids"
                                                                data={formData}
                                                                // selectOptions={{value: 'id',
                                                                //                 label: 'type',
                                                                //                 data: selectOptions.board}}
                                                                selectOptions={{value: 'id',
                                                                                label: 'label',
                                                                                data: schoolBoardOption}}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            {formData.is_board_other && (
                                                                <>
                                                                <FormInput
                                                                    colMd= "12"
                                                                    widthCls = "w-50 w-xs-100 w-sm-50"
                                                                    label= "1.2.1. Syllabi offered to students in your school currently"
                                                                    required= {true}
                                                                    type= "text"
                                                                    name= "board_name"
                                                                    data={formData}
                                                                    placeholder="Only if you have selcted `Others` above"
                                                                    // count= {100}
                                                                    updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                                />
                                                                </>
                                                            )}
                                                            <FormInput
                                                                colMd = "12"
                                                                label = "1.3. Are you nominating IFSPD Europe Future Global Leaders Fellowship in one school or in a group of schools?"
                                                                required = {true}
                                                                type = "radio"
                                                                name = "implement_type"
                                                                data={formData}
                                                                radioOptions={{value: 'id',
                                                                                label: 'type',
                                                                                data: nominationGroupOptions}}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            {formData.implement_type === 2 && (
                                                                <FormInput
                                                                    colMd = "12"
                                                                    widthCls = "w-25 w-xs-100 w-sm-50"
                                                                    label = "1.3.1. How many schools in your group are you nominating?"
                                                                    required = {true}
                                                                    type = "select"
                                                                    name = "school_count"
                                                                    data={formData}
                                                                    selectOptions={{value: 'id',
                                                                                    label: 'count',
                                                                                    data: schoolCountOptions()}}
                                                                    updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                                />
                                                            )}
                                                            <FormInput
                                                                colMd= "12"
                                                                widthCls = "w-25 w-xs-100 w-sm-50"
                                                                label= "1.4. How many students are there totally in your school?"
                                                                required= {true}
                                                                type= "text"
                                                                name= "student_count"
                                                                data={formData}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            <FormInput
                                                                colMd = "12"
                                                                label = "1.5. School Type"
                                                                required = {true}
                                                                type = "radio"
                                                                name = "school_type"
                                                                data={formData}
                                                                radioOptions={{value: 'id',
                                                                                label: 'label',
                                                                                data: schoolTypeOption}}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            {/* <div className="mod-form-input col-md-12 col-12">
                                                                <div>
                                                                    <label className="form-label" htmlFor="media_reports"><b>1.5.  Which month does your school academic calendar start and which month does it end?</b></label>
                                                                    <div className="d-flex">
                                                                        <FormInput
                                                                            colMd= "2"
                                                                            label= "Start Month"
                                                                            required= {true}
                                                                            type= "select"
                                                                            name= "start_month"
                                                                            data={formData}
                                                                            selectOptions={{value: 'id',
                                                                                            label: 'label',
                                                                                            data: monthOption}}
                                                                            updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                                        />
                                                                        <FormInput
                                                                            colMd= "2"
                                                                            colMdCls="ms-3"
                                                                            label= "End Month"
                                                                            required= {true}
                                                                            type= "select"
                                                                            name= "end_month"
                                                                            data={formData}
                                                                            selectOptions={{value: 'id',
                                                                                            label: 'label',
                                                                                            data: monthOption}}
                                                                            updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                        </fieldset>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                        <Accordion defaultActiveKey="1">
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>
                                                    <AccordionSecUI
                                                        title={"Nomination to IFSPD Europe Future Global Leaders Fellowship"}
                                                    />
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    IFSPD Europe Future Global Leaders Fellowship is a four-part capacity-building program to elevate students from the top schools to the <b>global stage of leadership, international relations, and entrepreneurship</b> — through Global Sustainability Councils, Social Startups, and leadership immersions. This elite program is reserved for the top-performing students. 50%+ of IFSPD Europe alumni secure top university admissions with scholarships. Alumni include UN national heads, Senators, CEOs, and leading Ivy League scholars.
                                                    <div className="mod-form-input">
                                                        <fieldset className="row">
                                                            {/* <FormInput
                                                                colMd= "12"
                                                                label= "2.1. Please select the programs you are interested in applying for the next academic year."
                                                                required= {true}
                                                                type= "multi-select"
                                                                name= "program_ids"
                                                                data={formData}
                                                                placeholder={["Select"]}
                                                                selectOptions={{value: 'id',
                                                                                label: 'label',
                                                                                data: nominationProgramOptions
                                                                            }}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            /> */}
                                                            <FormInput
                                                                colMd= "12"
                                                                label= "2.1. If your school is selected, do you agree to integrate IFSPD Europe Future Global Leaders Fellowship to your school calendar, for about 2 to 4 hours every month for 6 months."
                                                                required= {true}
                                                                type= "checkbox"
                                                                name= "integration_agree"
                                                                data={formData}
                                                                ch_label = "Yes"
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            <FormInput
                                                                colMd= "12"
                                                                label= "2.2. If your school is selected, do you agree to coordinate the collection of fees- € 90 per student- exclusive of any taxes."
                                                                required= {true}
                                                                type= "checkbox"
                                                                name= "coordination_agree"
                                                                data={formData}
                                                                ch_label = "Yes"
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            <FormInput
                                                                colMd= "12"
                                                                label= "2.3. What selection criteria and enrollment strategies will your school implement to ensure the successful shortlisting and enrollment of at least 150 students into the IFSPD Europe Future Global Leaders Fellowship?"
                                                                required= {false}
                                                                type= "textarea"
                                                                name= "selection_criteria"
                                                                data={formData}
                                                                count= {300}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            <FormInput
                                                                colMd = "12"
                                                                label = "2.4. Are you officially affiliated with any other international institutions connected to the United Nations?"
                                                                required = {true}
                                                                type = "radio"
                                                                name = "is_affi_internationally"
                                                                data={formData}
                                                                radioOptions={{value: 'id',
                                                                                label: 'title',
                                                                                data: yesNoOption}}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                            {formData.is_affi_internationally === 1 && (
                                                                <FormInput
                                                                    colMd= "12"
                                                                    label= "2.4.1. Name of the international organisation"
                                                                    required= {true}
                                                                    type= "text"
                                                                    name= "organisation_name"
                                                                    data={formData}
                                                                    // count= {30}
                                                                    updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                                />
                                                            )}
                                                        </fieldset>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                        <Accordion defaultActiveKey="2">
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>
                                                    <AccordionSecUI
                                                        title={"Contact Details"}
                                                    />
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="mod-form-input">
                                                        <fieldset className="row">
                                                            {/* <FormInput
                                                                colMd= "12"
                                                                label= "3.1. Contact details along with mobile numbers of the management committee of your school."
                                                                required= {true}
                                                                type= "textarea"
                                                                name= "committee_contact"
                                                                data={formData}
                                                                count= {300}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            /> */}
                                                             <FormInput
                                                                colMd= "12"
                                                                label= "3.1. Mobile number of the Principal of your school."
                                                                required= {true}
                                                                type= "text"
                                                                name= "principal_contact"
                                                                data={formData}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                             <FormInput
                                                                colMd= "12"
                                                                label= "3.2. Contact details along with mobile number of a single point of contact from your school, who will coordinate the roll out and management of IFSPD Europe Future Global Leaders Fellowship (please nominate someone other than the Principal)."
                                                                required= {false}
                                                                type= "textarea"
                                                                name= "nominated_contact"
                                                                data={formData}
                                                                count= {300}
                                                                updateInput= {(identifier_type, input_type, field, value) => updateInput(identifier_type, input_type, field, value)}
                                                            />
                                                        </fieldset>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                        {errorData.length > 0 && (
                                            <div className="alert alert-danger mt-4" role="alert">
                                                <p className="mb-2">Please enter/modify following Data:</p>
                                                <ul>
                                                {errorData.map((error, error_index) => (
                                                    <li key={`error_${error_index}`}>{error}</li>
                                                ))}
                                                </ul>
                                            </div>
                                        )}
                                        <div className="mt-4 text-center">
                                        {isProcess
                                            ?
                                                <button className="btn btn-primary bg-color-blue mb-2 mb-sm-0" disabled type="submit"><img className="loader" src={require('../../assets/images/loader.gif')} alt="Loader" /> Submitting...</button>
                                            :
                                            <button className="btn btn-primary bg-color-blue mb-2 mb-sm-0" type="submit" onClick={(e) => submitForm(e)}>Submit</button>
                                        }
                                        </div>
                                        </>
                                        }
                                    </div>
                                </div>
                                </>
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        </>
    )    
}

export default SchoolNomination;